var map = {
	"./closeFull.svg": "7d09",
	"./download.svg": "4dae",
	"./dunpai.svg": "d465",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./frozen.svg": "9804",
	"./futureTask.svg": "67c8",
	"./imgFull.svg": "c033",
	"./rotL.svg": "8b78",
	"./rotR.svg": "78a7",
	"./safecode.svg": "f173",
	"./scan.svg": "9a02",
	"./switchTask.svg": "ff95",
	"./templateManagement.svg": "edc3",
	"./templateManagement_active.svg": "0fa8",
	"./tip.svg": "f943",
	"./unUsed.svg": "d8fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";